import { getTranslatedCustomValueCaption } from '../../grid/defaultCellRender/SelectRender/utils';

const mapList = (list, texts, fieldName, translationKey) => {
  return list.map((item) => {
    const translatedListItem = getTranslatedCustomValueCaption(texts, fieldName, item?.id);
    if (!translatedListItem) return item;
    return { ...item, [translationKey]: translatedListItem };
  });
};

export const getTranslatedItems = (texts, list, fieldName, translationKey = 'value') => {
  if (!texts || !list || typeof fieldName !== 'string' || typeof translationKey !== 'string') return list;

  if (typeof list === 'object' && !Array.isArray(list)) {
    return {
      0: mapList(list[0], texts, fieldName, translationKey),
      1: mapList(list[1], texts, fieldName, translationKey),
    };
  }

  return mapList(list, texts, fieldName, translationKey);
};
